module.exports = __webpack_public_path__ + "media/images/front/icon-search-orange-0665fec7c3afa395e52a2a3a4117eb2c.svg";